import Movement from "./movement";

export default class Transition extends Movement {
  render = function () {
    this.setupContext();

    this.context.setLineDash([6, 6]);
    this.context.strokeStyle = "rgba(0, 0, 0, 1)";
    this.context.fillStyle = "rgba(0, 0, 0, 1)";

    this.renderMovement();
    this.renderArrow();
    this.resetContext();
  }

}
